import { NgComponentOutlet } from "@angular/common";
import { Component, Input, OnInit, Type, signal } from "@angular/core";
import type { ComponentLoader } from "src/app/config/customer.model";
import { environment } from "src/environments/environment";

/**
 * Renders a customer's ordered list of sections (see `CustomerConfig`).
 *
 * All the loaders are awaited together and set at once, so the sections appear
 * in their configured order rather than in whichever order their chunks land.
 */
@Component({
  selector: "app-customer-slots",
  imports: [NgComponentOutlet],
  templateUrl: "./customer-slots.component.html",
})
export class CustomerSlotsComponent implements OnInit {
  @Input({ required: true }) slots!: ComponentLoader[];

  components = signal<Type<unknown>[]>([]);

  async ngOnInit(): Promise<void> {
    // The components come from `environment.customer`, but the colours are
    // compiled in from the build configuration's `src/themes/<id>` in
    // angular.json — SCSS can't read an environment file. Say so when they
    // disagree instead of leaving a yellow page in a pink theme unexplained.
    const theme = getComputedStyle(document.documentElement).getPropertyValue("--customer-theme").trim();
    if (theme && theme !== environment.customer.id) {
      console.warn(
        `[customer] environment.customer is "${environment.customer.id}" but this build's theme is "${theme}". ` +
          `Colours follow the angular.json build configuration (stylePreprocessorOptions.includePaths), not the environment file.`,
      );
    }

    this.components.set(await Promise.all(this.slots.map((load) => load())));
  }
}
